// Add to Wishlist
$('.wishlist_link').on('click', function (e) {
  window.location.href = '/pages/wishlist';
});

$(document).on("click", ".wishlist-button", function (e) {
  e.preventDefault();
  var productId = $(this).attr('product-id');
  var productImg = $(this).find('.p_image').attr('data');
  var productTitle = $(this).find('.p_title').attr('data');
  var productPrice = $(this).find('.p_price').attr('data');
  var productUrl = $(this).find('.p_url').attr('data');
  
  // Get the wishlist from localStorage
  var wishlist = localStorage.getItem('wishlist') ? JSON.parse(localStorage.getItem('wishlist')) : [];

  var isProductInWishlist = wishlist.find(item => item.id === productId);

  if (!isProductInWishlist) {
    var productData = {
      id: productId,
      image: productImg,
      title: productTitle,
      price: productPrice,
      url: productUrl
    };

    wishlist.push(productData);

    // Store the updated wishlist in localStorage
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    $(this).find('.heart-icon.fill').addClass('active');
    $(this).find('.heart-icon.empty').removeClass('active');
  } else {
    var productIndex = wishlist.findIndex(item => item.id === productId);
    if (productIndex !== -1) {
      wishlist.splice(productIndex, 1);

      // Store the updated wishlist in localStorage
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      
      $(this).find('.heart-icon.fill').removeClass('active');
      $(this).find('.heart-icon.empty').addClass('active');
    }
  }
  wishlistCount();
});

// Remove from Wishlist
$(document).on("click", ".remove-wishlist-button", function (e) {
  e.preventDefault();
  var productId = $(this).attr('data-id');
  
  // Get the wishlist from localStorage
  var wishlist = localStorage.getItem('wishlist') ? JSON.parse(localStorage.getItem('wishlist')) : [];

  var productIndex = wishlist.findIndex(item => item.id === productId);

  if (productIndex !== -1) {
    wishlist.splice(productIndex, 1);

    // Store the updated wishlist in localStorage
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    $(this).closest('.wishlist-item').remove();
  }
  wishlistCount();
});

$('.wishlist-count-bubble').addClass('hide');

// Retrieve and display the stored wishlist products
var wishlist = localStorage.getItem('wishlist') ? JSON.parse(localStorage.getItem('wishlist')) : [];
var wishlistContainer = $('.wishlist-container');
wishlist.forEach(function (product, index) {
  wishlistCount();
  $('.wishlist-' + product.id).addClass('js_class');
  if (product.id != undefined) {
    var productHtml = `
      <div class="wishlist-item" data-id="${product.id}">
        <a href="https://cathedralcollection.com${product.url}"><img src="${product.image}" alt="Product Image"></a>
        <a href="https://cathedralcollection.com${product.url}"><h3>${product.title}</h3></a>
     
        <p>${product.price}</p>


  
        <button type="button" class="remove_item remove-wishlist-button" aria-label="Close" data-id="${product.id}">
          <svg class="icon icon-close" aria-hidden="true" focusable="false">
            <use href="#icon-close">
          </use></svg>
        </button>
      </div>
    `;
  }
  wishlistContainer.append(productHtml);
});

function wishlistCount() {
  $('.wishlist-count-bubble').addClass('hide');
  var wishlist = localStorage.getItem('wishlist') ? JSON.parse(localStorage.getItem('wishlist')) : [];

  // Filter out items with undefined id
  var validItems = wishlist.filter(item => item.id !== undefined);
  
  var uniqueIds = new Set(validItems.map(item => item.id)); // Use Set to get unique product IDs.
  var total_length = uniqueIds.size;


  if (total_length > 0) {
    $('.wishlist-count-bubble').removeClass('hide');
    $('.wishlist-count-bubble').text(total_length);
  } else {
    $('.wishlist-count-bubble').addClass('hide');
  }
}






